import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class verificationService {
    start(data) {
        // console.log('play');
        return axios.post(API_URL+'two-factor-authentication/setup-start', data, { headers: authHeader() });
    }
    setupEmail(data) {
        return axios.post(API_URL+'two-factor-authentication/setup-email', data, { headers: authHeader() });
    }
    setupCheck(data) {
        return axios.post(API_URL+'two-factor-authentication/setup-check', data, { headers: authHeader() });
    }
    setupActivate(data) {
        return axios.post(API_URL+'two-factor-authentication/activate', data, { headers: authHeader() });
    }
    setupDeactivate(data) {
        return axios.post(API_URL+'two-factor-authentication/deactivate', data, { headers: authHeader() });
    }
    VerifPassword(data) {
        return axios.post(API_URL+'auth/verify-password', data, { headers: authHeader() });
    }

    setupAuth(data) {
        return axios.post(API_URL+'two-factor-authentication/app/qr-code', data, { headers: authHeader() });
    }
    verifyOTP(data) {
        return axios.post(API_URL+'two-factor-authentication/app/verify-otp', data, { headers: authHeader() });
    }
    setupAuthChanges(data) {
        return axios.post(API_URL+'two-factor-authentication/app/reauthenticate/qr-code', data, { headers: authHeader() });
    }
    verifyOTPChanges(data) {
        return axios.post(API_URL+'two-factor-authentication/app/reauthenticate/verify-otp', data, { headers: authHeader() });
    }
    deleteAuthapp(data) {
        return axios.post(API_URL+'two-factor-authentication/app/remove', data, { headers: authHeader() });
    }
}

export default new verificationService();
